import type { Customer, Product } from '@/models';
import { getBrowserSupabaseClient } from '@/repositories/supabase-auth-clients';
import { wholesalePriceRepository } from '@/repositories';

export function isWholesaleCustomer(customer: Customer | null): boolean {
  return customer !== null && customer.isActive && customer.priceTier === 'wholesale';
}

export async function getProductForCustomer(
  product: Product | null,
  customer: Customer | null
): Promise<Product | null> {
  if (!product || !isWholesaleCustomer(customer)) {
    return product;
  }

  const wholesalePrice = await wholesalePriceRepository.getByProductId(product.id);
  return wholesalePrice == null ? product : { ...product, wholesalePrice };
}

export async function listViewerWholesalePrices(): Promise<Record<string, number>> {
  if (typeof window === 'undefined') {
    return {};
  }

  const supabase = getBrowserSupabaseClient();
  const { data, error } = await supabase
    .from('product_wholesale_prices')
    .select('product_id, price');

  if (error || !data) {
    return {};
  }

  return data.reduce<Record<string, number>>((acc, row) => {
    acc[row.product_id] = Number(row.price);
    return acc;
  }, {});
}
